'use strict'

# Import/Require the local "logic_signal" module
Logic_Signal = require('./logic_signal')

# Require the "nixfilter" module
nixfilter = require('nixfilter')

# A reader for logic signals
logic_signal_reader = (encoding) ->
	(callback) ->
		nixfilter.reader.line(encoding) (input_line) ->
			callback(new Logic_Signal(input_line))
			return

# What this module exports
module.exports =
	logic_signal: logic_signal_reader
